import { html, type TemplateResult } from '@design.estate/dees-element';

export function demoFunc(): TemplateResult {
  return html`
    <style>
      .sparklebox-demo {
        display: grid;
        gap: 24px;
        padding: 24px;
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        font-family: 'Inter', sans-serif;
      }
      .sparklebox-demo h3 {
        margin: 0 0 8px;
        font-size: 12px;
        font-weight: 600;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        opacity: 0.6;
        font-family: monospace;
        color: var(--dees-color-text-primary);
      }
      .sparklebox-demo dees-sparklebox {
        height: 220px;
        border-radius: 8px;
      }
      .sparklebox-demo .full {
        grid-column: 1 / -1;
      }
      .sparklebox-demo .full dees-sparklebox {
        height: 300px;
      }
      .sparklebox-hero {
        display: flex;
        height: 100%;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 6px;
        text-align: center;
        color: var(--dees-color-text-primary);
      }
      .sparklebox-hero .title {
        font-size: 30px;
        font-weight: 600;
        letter-spacing: -0.02em;
      }
      .sparklebox-hero .subtitle {
        font-size: 14px;
        opacity: 0.7;
      }
    </style>

    <div class="sparklebox-demo">
      <div>
        <h3>default (theme-aware)</h3>
        <dees-sparklebox></dees-sparklebox>
      </div>

      <div>
        <h3>custom colors</h3>
        <dees-sparklebox colors="#60a5fa, #3b82f6, #2563eb"></dees-sparklebox>
      </div>

      <div>
        <h3>dense · slow</h3>
        <dees-sparklebox gap="4" speed="12" colors="#34d399, #10b981, #059669"></dees-sparklebox>
      </div>

      <div>
        <h3>sparse · fast · no vignette</h3>
        <dees-sparklebox gap="10" speed="80" .vignette=${false}></dees-sparklebox>
      </div>

      <div class="full">
        <h3>with slotted content</h3>
        <dees-sparklebox colors="#a78bfa, #8b5cf6, #7c3aed">
          <div class="sparklebox-hero">
            <div class="title">central.eu</div>
            <div class="subtitle">European datacenters</div>
          </div>
        </dees-sparklebox>
      </div>
    </div>
  `;
}
